<script setup>
defineProps(['model'])
</script>

<template>
  <div class="flex justify-center">
    <NuxtLink :to="useCmsUrl(model.logoLink?.value)">
      <NuxtImg
        provider="fastlyAprimo"
        fit="bounds"
        class="h-20 w-full max-w-40 object-contain"
        :src="model.aprimoImage?.url || model.imageUrl?.value"
        :width="160"
        :alt="model.imageAltText?.value"
      />
    </NuxtLink>
  </div>
</template>
